var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","height":_vm.size + 'px',"viewBox":"0 -960 960 960","width":_vm.size + 'px',"fill":"currentColor"}},[_c('path',{attrs:{"d":"m600-200-57-56 184-184H80v-80h647L544-704l56-56 280 280-280 280Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }